export const wordIndexFromOffset = (offset, text) =>
  text
    .slice(0, offset + 1)
    .trim()
    .split(/\s+/).length - 1



// WEBPACK FOOTER //
// ../src/utils/textHelper.js